/* eslint-disable */
export default deg => {
    const cardinals = [
      "N",
      "NNE",
      "NE",
      "ENE",
      "E",
      "ESE",
      "SE",
      "SSE",
      "S",
      "SSO",
      "SO",
      "OSO",
      "O",
      "ONO",
      "NO",
      "NNO"
    ];
    if (deg == 999) return "-";
    var idx = deg === 360 ? 0 : Math.floor(deg / 22.5);
    return cardinals[idx];
  };
  